import React from "react";
import md5 from "md5";
import "./Gravatar.scss";
const Gravatar = (props) => {
  const getUrl = () => {
    if (!!props.email) {
      let hash = md5(props.email.toLowerCase());
      return `https://gravatar.com/avatar/${hash}`;
    } else {
      return `https://gravatar.com/avatar/`;
    }
  };

    return !!props.isVisible ? <img src={getUrl()} alt="" className="non-gravatar" /> : "";
};

export default Gravatar;
